import React from 'react';
import Content from './Content';

const RightPane = ({ eventDetails }) => {
  const content = <Content key={ eventDetails.id } {...eventDetails} />

  return(
    <>
      <div className='col-4 d-none d-md-block cui-event-right-pane-web'>
        { content }
      </div>
      <div className='col-12 pr-0 pl-2 d-md-none cui-event-right-pane-mobile'>
        { content }
      </div>
    </>
  )
};

export default RightPane;